module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-aoj_d-2301e52bf8b0d3d9edff39b8effc761b.jpg";